
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-9363ab12&scoped=true!sass-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ContentLoader.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ContentLoader.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-9363ab12!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ContentLoader.vue"),
  /* scopeId */
  "data-v-9363ab12",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/main/ContentLoader.vue
// module id = 44
// module chunks = 2